export function target() {
  return this.module === 'Footer' && !this.data.socialLinks;
}

export function migrate() {
  const socialLinks = [];
  const { instagramLink, youTubeLink, facebookLink, tripAdvisorLink } =
    this.data;

  if (instagramLink.value) {
    socialLinks.push({
      socialType: 'instagramLink',
      title: '',
      linkURL: {
        type: 'externalLink',
        value: instagramLink.value,
        openInNewTab: instagramLink.openInNewTab,
      },
    });
  }

  if (youTubeLink.value) {
    socialLinks.push({
      socialType: 'youTubeLink',
      title: '',
      linkURL: {
        type: 'externalLink',
        value: youTubeLink.value,
        openInNewTab: youTubeLink.openInNewTab,
      },
    });
  }

  if (facebookLink.value) {
    socialLinks.push({
      socialType: 'facebookLink',
      title: '',
      linkURL: {
        type: 'externalLink',
        value: facebookLink.value,
        openInNewTab: facebookLink.openInNewTab,
      },
    });
  }

  if (tripAdvisorLink.value) {
    socialLinks.push({
      socialType: 'tripAdvisorLink',
      title: '',
      linkURL: {
        type: 'externalLink',
        value: tripAdvisorLink.value,
        openInNewTab: tripAdvisorLink.openInNewTab,
      },
    });
  }

  this.data.socialLinks = socialLinks;
  delete this.data.instagramLink;
  delete this.data.youTubeLink;
  delete this.data.facebookLink;
  delete this.data.tripAdvisorLink;
}
